/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useContext, useEffect } from "react";
import { openDB } from "idb";
import { useNavigate } from "react-router-dom";
import { MenuBookTwoTone, Delete, Download } from '@mui/icons-material';
import CopyAllIcon from '@mui/icons-material/CopyAll';
import { XIcon } from "@heroicons/react/solid";
import { v4 as uuidv4 } from "uuid";
import Context from "../context/context";
import axios from "axios";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
const MasterMenuFilters = ({ setSelectedMenu, selectedMenu, menus, setMenus, newMenuPopup }) => {

  const [brandName, setBrandName] = useState([]);
  const [copyMenuOpen, setCopyMenuOpen] = useState(false);
  const [confirmMenuDeletePopup, setConfirmMenuDeletePopup] = useState(false);
  const [items, setItems] = useState([]);
  const [category, setCategory] = useState([]);
  const navigate = useNavigate();
  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';
  const context = useContext(Context);
  const { setUnAuthPopup, updateUnSync } = context;
  
  let restrictions = JSON.parse(sessionStorage.getItem("restrictions")) || []
  useEffect(() => {
    const getDataFromIndexdDb = async () => {
      const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
      const indSections = await db.transaction("menu", "readonly").objectStore("menu");
      const currentSections = await indSections.getAll();
      setSelectedMenu(currentSections[0])
      setMenus(currentSections.filter(a => a.menu_type.filter(b => +b !== 5).length));
      let store = await db.transaction("category", "readonly").objectStore("category");
      let categoryData = await store.getAll()
      setCategory(categoryData)
      store = await db.transaction("item", "readonly").objectStore("item");
      let itemData = await store.getAll()
      setItems(itemData)

    };
    getDataFromIndexdDb();
  }, [newMenuPopup]);
  useEffect(() => {
    const getDataFromIndexdDb = async () => {
      const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
      const indSections = await db.transaction("brand", "readonly").objectStore("brand");
      const currentSections = await indSections.getAll();
      setBrandName(currentSections);
    };
    getDataFromIndexdDb();
  }, []);

  const noWarning = () => {
    setUnAuthPopup(true);
    setTimeout(() => setUnAuthPopup(false), 3000);
  }
  const deleteHandler = async (menu_uuid) => {
    let outlet_uuid = localStorage.getItem("outlet_uuid")
    const response = await axios({
      method: "delete",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      url: "https://api.myfooddo.com/menu/deleteMenu",
      data: [{ outlet_uuid, menu_uuid }]
    })
    if (response.data.success) {
      const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
      const store = await db.transaction("menu", "readwrite").objectStore("menu");
      await store.delete(menu_uuid)
      let menu = await store.getAll()
      setMenus(menu)
    }
  }
  const downloadHandler = async (menuData) => {
    // let sheetData = menuData.category_and_items.map(a=>a.menu_items.map(b=>({category_uuid:a.category_uuid,...b})))
    console.log(menuData.category_and_items[0].menu_items.map(a => items.find(b => a.item_uuid === b.item_uuid)))
    let sheetData = [].concat.apply(
      [],
      [].concat
        .apply([], menuData?.category_and_items)
        ?.map((item2) =>
          item2.menu_items?.map((a) => category.filter(b => b.category_uuid === item2.category_uuid).length ? (

            {
              ...a, item_mode: item2.item_mode || "0", category_uuid: item2.category_uuid, ...category.find(b => b.category_uuid === item2.category_uuid),
              ...items.find(b => b.item_uuid === a.item_uuid)
            }
          ) : null)
        )
    )?.filter(a => a)
    sheetData = sheetData.map(a => {
      // console.log(a)
      return {
        "Category Name": a.category_name,
        "Item": a.item_name,
        "Brand UUID": a.brand_uuid,
        "Item Code": a?.outlet_wise_item_details?.length ? a?.outlet_wise_item_details[0]?.other_details?.item_code : "",
        "ItemMode": a.item_mode || "",
        "GST%": a?.outlet_wise_item_details?.length ? a?.outlet_wise_item_details[0]?.other_details?.item_gst : "0",
        "VAT%": a?.outlet_wise_item_details?.length ? a?.outlet_wise_item_details[0]?.other_details?.item_vat : "0",
        "Parcel Type": a?.outlet_wise_item_details?.length ? a?.outlet_wise_item_details[0]?.other_details?.item_parcel_type : "0",
        "Exclude from Discount": a?.outlet_wise_item_details?.length ? a?.outlet_wise_item_details[0]?.other_details?.item_excluded_from_discount : "0",
        "Exclude from Charge": a?.outlet_wise_item_details?.length ? a?.outlet_wise_item_details[0]?.other_details?.item_excluded_from_charge : "0",
        "Status": a.menu_item_status || "0",
        "Price": a.menu_item_price || "0",
        "Parcel Charge": a.menu_item_parcel_charge || "0",
        "Description": a.menu_item_description || "",

      }
    })
    // console.log(sheetData)
    const ws = XLSX.utils.json_to_sheet(sheetData);
    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, menuData.menu_title + fileExtension);
  }

  return (
    <>
      <div className="master-menu-filters">
        {menus.length > 0 &&
          menus.map((menu, i) => (
            <div
              className={`master-menu-filter ${selectedMenu.IDENTIFIER === menu.IDENTIFIER ? "selected" : ""}`}
              onDoubleClick={() =>
                +restrictions[0]?.other_menu_and_seat_open_menu_and_edit === 0 ? noWarning() :
                  navigate(`/page4/${menu.brand_uuid}/${menu.menu_uuid}`)
              }
              onClick={() => {

                setSelectedMenu(menu);
              }}
              key={i}
            >
              <h4>
                {menu.menu_title ? menu.menu_title.slice(0, 9) : 'Menu'}
                {menu.menu_title?.length > 10 && "..."}
              </h4>
              <p>
                {brandName?.length > 0 &&
                  brandName.find(
                    (brand) => brand.brand_uuid === menu.brand_uuid
                  )?.brand_name?.slice(0, 9)}
                {brandName?.length > 0 &&
                  brandName.find(
                    (brand) => brand.brand_uuid === menu.brand_uuid
                  )?.brand_name?.length > 10 && "..."
                }
              </p>
              <MenuBookTwoTone sx={{ color: "#febd69", fontSize: '50px' }} />
              <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                <Delete sx={{ color: "red" }} onClick={() => setConfirmMenuDeletePopup(menu.menu_uuid)} />
                <Download sx={{ color: "#44cd4af0" }} onClick={() => downloadHandler(menu)} />
                <CopyAllIcon sx={{ color: "#44cd4af0" }} onClick={() => setCopyMenuOpen(true)} />
              </div>
            </div>
          ))}
      </div>
      {copyMenuOpen ? <CopyMenu close={() => setCopyMenuOpen(false)} selectedMenu={selectedMenu} setMenus={setMenus} menus={menus} /> : ""}
      {confirmMenuDeletePopup ? <DeleteMenu close={() => setConfirmMenuDeletePopup(false)} updateUnSync={updateUnSync} onConfirm={() => {
        deleteHandler(confirmMenuDeletePopup);
        setConfirmMenuDeletePopup(false)
      }} /> : ""}
    </>
  );
};

export default MasterMenuFilters;
const CopyMenu = ({ close, selectedMenu, setMenus, menus, updateUnSync }) => {
  const [newMenu, setNewMenu] = useState({})
  const MenuSyncedOut = async () => {

    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = db.transaction("unsynced_files", "readwrite").objectStore("unsynced_files");

    const ndata = {
      ...newMenu,
      RECON_TIME: newMenu.RECON_TIME,
      IDENTIFIER: "menu-new:" + newMenu.menu_uuid,
      date: ""
    };
    await tx.put(ndata)
    updateUnSync()
  }
  const handleReconciliation = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("reconciliation", "readwrite")
      .objectStore("reconciliation");
    const allReconRecords = await tx.getAll();

    const sectionsJsonExists = allReconRecords.find(
      (curr) => curr.IDENTIFIER === "menu"
    );
    if (sectionsJsonExists) {
      const sections = sectionsJsonExists?.details?.filter(
        (section) => section.menu_uuid !== data.menu_uuid
      );
      const editData = {
        ...sectionsJsonExists,
        details: [
          ...sections,
          {
            menu_uuid: data.menu_uuid,
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.put(editData);
    } else {
      const newdata = {
        IDENTIFIER: "menu",
        details: [
          {
            menu_uuid: data.menu_uuid,
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.add(newdata);
    }
  };
  const updateData = async () => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = db.transaction("menu", "readwrite").objectStore("menu");

    await tx.put(Object.keys(newMenu)
      .filter((key) => key !== "RECON_TIME")
      .reduce((obj, key) => {
        obj[key] = newMenu[key];
        return obj;
      }, {}));


  }
  useEffect(() => {
    var id = uuidv4();

    setNewMenu({
      ...selectedMenu,
      menu_title: "",
      menu_type: ["0"],
      menu_uuid: id,
      IDENTIFIER: id,
      RECON_TIME: new Date().getTime().toString()
    });

  }, [])
  return <div className="newCategory">
    <div className="newCatContainer">
      <div className="newCatContainer_header">
        <h2>Copy Menu</h2>
        <XIcon className="closeicon" onClick={close} />
      </div>
      <div className="newCatContainer2">
        <div className="cat-inp">
          <label htmlFor="catname">Menu Title</label>
          <input
            value={newMenu.menu_title}
            onChange={(e) => setNewMenu({ ...newMenu, menu_title: e.target.value })}
            maxLength={15}
            type="text"
            id="catname"
          />
        </div>

        <button disabled={newMenu.menu_title === ""} onClick={async () => {
          setMenus([...menus, newMenu]);
          await updateData()
          await MenuSyncedOut();
          await handleReconciliation(newMenu);
          await close();
        }}>Save</button>

      </div>
    </div>
  </div>
}
const DeleteMenu = ({ close, onConfirm }) => {

  return <div className="logoutPopup">
    <div className="logout_content">
      <h2>Are you sure you want to Delete Menu ?</h2>
      <h3>
        Note: Items and Categories will not get deleted.</h3>
      <div className="logout_button">
        <div className="button_container">

          <button className="simple_Logout_button" onClick={onConfirm}>
            Confirm
          </button>


        </div>
        <div className="button_container">

          <button
            className="clear_Logout_button"
            style={{ background: "red" }}
            onClick={close}
          >
            Cancel
          </button>


        </div>
      </div>
    </div>
  </div>
}
